export default "__VITE_ASSET__DSQx46gc__ 100w";